import { backgroundOrange } from '@/theme/colors'
import styled from 'styled-components'

export const BalancesPageContainer = styled.div`
	background-color: ${backgroundOrange};
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
`

export const LoadingContainer = styled.div`
	display: flex;
	flex: 1;
	justify-content: center;
	align-items: center;
	background-color: ${backgroundOrange};
	height: 100%;
`

export const ErrorContainer = styled.div`
	padding: 2rem;
	text-align: center;
	color: red;
`

export const ContentContainer = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	min-height: 0;
	padding: 1.5rem;

	@media (max-width: 600px) {
		padding: 1rem 0.875rem;
	}
`

export const SplitLayout = styled.div`
	display: flex;
	gap: 1.5rem;
	flex: 1;
	min-height: 0;

	@media (max-width: 900px) {
		display: none;
	}
`

export const MembersColumn = styled.section`
	flex: 0 0 380px;
	min-width: 0;
	display: flex;
	flex-direction: column;
	background: white;
	border: 1px solid #f0e0d6;
	border-radius: 14px;
	padding: 1rem 1rem 1rem 1.25rem;
`

export const ActivityColumn = styled.section`
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	background: white;
	border: 1px solid #f0e0d6;
	border-radius: 14px;
	padding: 1rem 1rem 1rem 1.25rem;
`

export const MobileLayout = styled.div`
	display: none;
	flex: 1;
	min-height: 0;
	flex-direction: column;

	@media (max-width: 900px) {
		display: flex;
	}
`

export const MobilePanel = styled.div<{ $active: boolean }>`
	display: ${({ $active }) => ($active ? 'flex' : 'none')};
	flex-direction: column;
	flex: 1;
	min-height: 0;
	background: white;
	border: 1px solid #f0e0d6;
	border-radius: 14px;
	padding: 1rem 1rem 1rem 1.25rem;
`
